import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://5242f96db8d5f023740f4c5e72e06ea0@o4506354936971264.ingest.sentry.io/4506354945556480",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});